export default "__VITE_ASSET__BpXAn3Q8__"